/* cmp-lead: aggancia i form del sito all'endpoint che scrive su ActiveCampaign.
   Un form partecipa dichiarandosi: data-cmp-lead="<sorgente>".
   La sorgente decide il tag su AC, quindi quale automazione si accende.
   Senza JavaScript il form non parte: il bottone resta, ma non si perde nessun
   indirizzo per strada perche' il submit nativo e' bloccato solo se fetch esiste. */
(function () {
  var ENDPOINT = 'https://live.matteoborea.it/cmp-lead/subscribe';
  var S = window.cmpLeadStrings || {};

  function message(form, text, ok) {
    var box = form.parentNode.querySelector('.cmp-lead-msg');
    if (!box) {
      box = document.createElement('p');
      box.className = 'cmp-lead-msg';
      form.parentNode.insertBefore(box, form.nextSibling);
    }
    box.textContent = text;
    box.setAttribute('role', 'status');
    box.style.margin = '12px 0 0';
    box.style.fontSize = '14px';
    box.style.lineHeight = '1.5';
    box.style.color = ok ? '#7ec9a5' : '#f5934a';
  }

  /* Sostituisce il dominio con quello proposto dal servizio, se serve davvero.
     Torna null quando non c'e' proposta, quando l'indirizzo e' storto o quando
     il dominio e' gia' quello giusto: in quei casi non si tocca cio' che ha
     scritto la persona. */
  function fixDomain(value, suggestion) {
    if (!suggestion || typeof value !== 'string') return null;
    var parts = value.trim().split('@');
    if (parts.length !== 2 || !parts[0]) return null;
    if (parts[1].toLowerCase() === String(suggestion).toLowerCase()) return null;
    return parts[0] + '@' + suggestion;
  }

  function wire(form) {
    if (!window.fetch || form.dataset.cmpLeadWired) return;
    form.dataset.cmpLeadWired = '1';

    // honeypot: invisibile a chi legge, irresistibile per un bot
    var trap = document.createElement('input');
    trap.type = 'text';
    trap.name = 'company';
    trap.tabIndex = -1;
    trap.autocomplete = 'off';
    trap.setAttribute('aria-hidden', 'true');
    trap.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0';
    form.appendChild(trap);

    var btn = form.querySelector('button[type=submit]');
    var input = form.querySelector('input[type=email]');
    var label = btn ? btn.textContent : '';

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      S = window.cmpLeadStrings || S; /* the layout defines the strings after the page content: read them when the form is sent */
      if (!input || !input.value) return;
      if (btn) { btn.disabled = true; btn.textContent = S.sending || 'Sending...'; }

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: input.value.trim(),
          company: trap.value,
          source: form.dataset.cmpLead || 'unknown'
        })
      }).then(function (r) {
        return r.json().catch(function () { return { ok: r.ok }; });
      }).then(function (data) {
        if (data && data.ok) {
          form.style.display = 'none';
          message(form, form.dataset.cmpOk ? form.dataset.cmpOk : String(form.dataset.cmpLead).indexOf('newsletter') === 0
            ? (S.okNewsletter || 'You are in. Check your inbox: a note from me is on its way, and one thing a week from there.')
            : (S.okFree || 'Check your inbox: the Coffee Cost Calculator is on its way.'), true);
        } else {
          var why = S.errGeneric || 'Something went wrong on our side. Try again in a minute.';
          if (data && data.error === 'bad_email') {
            // il servizio dice anche PERCHE': reason 'no_mx' vuol dire che quel
            // dominio non ha un server di posta, e suggestion e' il provider
            // noto piu' vicino quando l'indirizzo sembra un refuso.
            var corretto = fixDomain(input.value, data.suggestion);
            if (corretto) {
              input.value = corretto;
              why = (S.errDomainFixed || 'We could not find a mail server at that domain. We changed it to ') +
                    corretto + ', send again if that is right.';
            } else if (data.reason === 'no_mx') {
              why = S.errDomain || 'We could not find a mail server for that domain. Check the spelling?';
            } else {
              why = S.errBad || 'That address does not look right. Try again?';
            }
          }
          message(form, why, false);
          if (btn) { btn.disabled = false; btn.textContent = label; }
        }
      }).catch(function () {
        message(form, S.errGeneric || 'Something went wrong on our side. Try again in a minute.', false);
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
    });
  }

  function boot() {
    document.querySelectorAll('form[data-cmp-lead]').forEach(wire);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
